/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Ai_Point_DiscoveryInputs */

const en_directory_hubs_signals_ai_point_discovery = /** @type {(inputs: Directory_Hubs_Signals_Ai_Point_DiscoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs and MCP/skill surfaces are acquisition channels that do not depend on search rankings — agents discover tools through registries and documentation, not ads.`)
};

const zh_directory_hubs_signals_ai_point_discovery = /** @type {(inputs: Directory_Hubs_Signals_Ai_Point_DiscoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档与 MCP/Skill 入口是不依赖搜索排名的获客渠道——Agent 通过注册表和文档发现工具，而不是广告。`)
};

/**
* | output |
* | --- |
* | "Docs and MCP/skill surfaces are acquisition channels that do not depend on search rankings — agents discover tools through registries and documentation, not ..." |
*
* @param {Directory_Hubs_Signals_Ai_Point_DiscoveryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_ai_point_discovery = /** @type {((inputs?: Directory_Hubs_Signals_Ai_Point_DiscoveryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Ai_Point_DiscoveryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_ai_point_discovery(inputs)
	return zh_directory_hubs_signals_ai_point_discovery(inputs)
});
export { directory_hubs_signals_ai_point_discovery as "directory.hubs.signals.ai.point.discovery" }